    
      //视觉优化：根据维度和颜色设置option颜色
    export function  setDimensionsofXYaxis (all_dimensions, colors, option) {
        let seriex_classtype = '';
        let name = '';
        let colors_cnt = 0;
        if (colors) {
          colors_cnt = colors.length;
        }
        seriex_classtype = Object.prototype.toString.call(option.series)
        //获取series data
        if (seriex_classtype == '[object Object]') {
          if (option.series.type == 'wordCloud' || option.series.type == 'candlestick' || option.series.type == "graph") {
          } else {
            name = option.series.name
            if (name != undefined && name != '') {
              findIndex = all_dimensions.indexOf(name);
              if (findIndex >= 0) {
                let color = ''
                if (findIndex < colors_cnt) {
                  color = colors[findIndex]
                } else {
                  let index = findIndex % colors_cnt;
                  color = colors[index]
                }
                if (color != '') {
                  option.series.color = color
                }
              }///
            }
          }

        } else if (seriex_classtype == '[object Array]') {
          let i = 0;
          let findIndex = -1;
          for (i = 0; i < option.series.length; i++) {
            if (option.series[i].type == 'wordCloud' || option.series[i].type == 'candlestick' || option.series[i].type == "graph") {
              continue
            }
            name = option.series[i].name
            if (name != undefined || name != '') {
              findIndex = all_dimensions.indexOf(name);
              if (findIndex >= 0) {
                let color = ''
                if (findIndex < colors_cnt) {
                  color = colors[findIndex]
                } else {
                  let index = findIndex % colors_cnt;
                  color = colors[index]
                }
                if (color != '') {
                  option.series[i].color = color
                }
              }///
            }
          }
        }
        return option
      }
      //视觉优化：清除视觉优化中设置option颜色
      export function  clearDimensionsofXYaxis (option) {
        let seriex_classtype = '';
          
        seriex_classtype = Object.prototype.toString.call(option.series)
        //获取series data
        if (seriex_classtype == '[object Object]') {
          if (option.series.type == 'wordCloud' || option.series.type == 'candlestick' || option.series.type == "graph") {
          } else {
            if (option.series.color) {
              delete option.series.color
            }
          }

        } else if (seriex_classtype == '[object Array]') {
          let i = 0;
          let findIndex = -1;
          for (i = 0; i < option.series.length; i++) {
            if (option.series[i].type == 'wordCloud' || option.series[i].type == 'candlestick' || option.series[i].type == "graph") {
              continue
            }
            if (option.series[i].color) {
              delete option.series[i].color
            }
          }
        }
        return option
      }
      //视觉优化：设置无坐标系的维度的颜色并渲染
      export function  setDimensionsofNoaxis (all_dimensions, colors, option) {
        let seriex_classtype = Object.prototype.toString.call(option['series']);
        let name = '';
        let findIndex = -1;
        let colors_cnt = colors.length
        if (seriex_classtype == '[object Object]') {
          if (option.series.type == 'wordCloud' || option.series.type == 'candlestick' || option.series.type == 'graph') {
            return option
          }
          if (option.series.data) {
            for (let i = 0; i < option.series.data.length; i++) {
                
              name = option.series.data[i].name
              if (name != undefined && name != '') {
                findIndex = all_dimensions.indexOf(name);
                if (findIndex >= 0) {
                  let color = ''
                  if (findIndex < colors_cnt) {
                    color = colors[findIndex]
                  } else {
                    let index = findIndex % colors_cnt;
                    color = colors[index]
                  }
                  if (color != '') {
                    if (option.series.data[i].itemStyle == undefined) {
                      option.series.data[i].itemStyle = {}
                    }
                    option.series.data[i].itemStyle.color = color
                  }
                }
              }
            }//for i
          }
        } else if (seriex_classtype == '[object Array]') {
          for (let h = 0; h < option.series.length; h++) {
            if (option.series[h].type == 'wordCloud' || option.series[h].type == 'candlestick' || option.series[h].type == 'graph') {
              continue
            }
            if (option.series[h].data) {
              for (let i = 0; i < option.series[h].data.length; i++) {
                 
                name = option.series[h].data[i].name
                if (name != undefined && name != '') {
                  findIndex = all_dimensions.indexOf(name);
                  if (findIndex >= 0) {
                    let color = ''
                    if (findIndex < colors_cnt) {
                      color = colors[findIndex]
                    } else {
                      let index = findIndex % colors_cnt;
                      color = colors[index]
                    }
                    if (color != '') {
                      if (option.series[h].data[i].itemStyle == undefined) {
                        option.series[h].data[i].itemStyle = {}
                      }
                      option.series[h].data[i].itemStyle.color = color
                    }
                  }
                }
              }//for i
            }
          }//for h
        }
        return option
      }
      //视觉优化：清除无坐标系的维度的颜色
      export function  clearDimensionsofNoaxis (option) {
        let seriex_classtype = Object.prototype.toString.call(option['series']);
        if (seriex_classtype == '[object Object]') {
          if (option.series.type == 'wordCloud' || option.series.type == 'candlestick' || option.series.type == 'graph') {
            return option
          }
          if (option.series.data) {
            for (let i = 0; i < option.series.data.length; i++) {
              if (option.series.data[i].itemStyle) {
                if (option.series.data[i].itemStyle.color) {
                  delete option.series.data[i].itemStyle.color
                }
              }
            }//for i
          }
        } else if (seriex_classtype == '[object Array]') {
          for (let h = 0; h < option.series.length; h++) {
            if (option.series[h].type == 'wordCloud' || option.series[h].type == 'candlestick' || option.series[h].type == 'graph') {
              continue
            }
            if (option.series[h].data) {
              for (let i = 0; i < option.series[h].data.length; i++) {
                if (option.series[h].data[i].itemStyle) {
                  if (option.series[h].data[i].itemStyle.color) {
                    delete option.series[h].data[i].itemStyle.color
                  }
                }
              }//for i
            }
          }//for h
        }
        return option
      }
      //视觉优化： 合并所有title legend xy轴等配置到option中
      export function  mergeColorsetting2Option (option, zuobiaoxi, allColorsetting) {
        let key = ''
        //-1未知  0 无坐标系  1 直角  2 单轴  3 极坐标  4 雷达坐标 5 地理坐标 6 日历坐标  7 平行坐标  8关系类图
        for (key in allColorsetting) {
          if (key == 'title' || key == 'legend') {
            option = mergeOneprototype(option, key, allColorsetting[key]);
            continue;
          }
          if (zuobiaoxi == 0) {
            //看是否是设计图型

            if(option.hlname != undefined) {
            //设计图型
              if(allColorsetting.title && allColorsetting.title.textStyle && allColorsetting.title.textStyle.color)
                option.color = allColorsetting.title.textStyle.color;
            }
          } else if (zuobiaoxi == 1) {
            if (key == 'xAxis' || key == 'yAxis') {
              option = mergeOneprototype(option, key, allColorsetting[key]);
            }
          } else if (zuobiaoxi == 2) {
            if (key == 'singleAxis') {
              option = mergeOneprototype(option, key, allColorsetting[key]);
            }
          } else if (zuobiaoxi == 3) {
            if (key == 'radiusAxis') {
              option = mergeOneprototype(option, key, allColorsetting[key]);
            }
          } else if (zuobiaoxi == 4) {
            if (key == 'radarAxis') {
              option = mergeOneprototype(option, key, allColorsetting[key]);
            }
          } else if (zuobiaoxi == 5) {

          } else if (zuobiaoxi == 6) {

          } else if (zuobiaoxi == 7) {

          } else if (zuobiaoxi == 8) {
          }
        }
        return option
      } 
      export function  DowithvalueEditAlias(settingobj, data) {
        let curdatas = data.data
        if (settingobj.type === 'multivalue') {
          //对数据的name进行处理，按照界面上修改的别名处理
          if (settingobj.value_editAlias) {
            let tmp_type = Object.prototype.toString.call(settingobj.value_editAlias);
            if (tmp_type == '[object Array]') {
              let findIndex = -1;
              for (let kk = 0; kk < curdatas.length; kk++) {
                findIndex = settingobj.value.indexOf(curdatas[kk].name);
                if (findIndex >= 0) {
                  if (settingobj.value_editAlias.length > findIndex) {
                    curdatas[kk].name = settingobj.value_editAlias[findIndex]
                  }
                }
              }
            } else if (tmp_type == '[object String]') {
              if (curdatas.length > 0 && settingobj.value_editAlias && settingobj.value_editAlias != '') {
                curdatas[0].name = settingobj.value_editAlias
              }
            }
            data.data = curdatas
          }
        } /*else if (settingobj.type === 'data') {
            //数据格式 [{channel:'dd',ticketcnt:12},{channel:'ad',ticketcnt:42}]
            if (settingobj.value_editAlias) {
              let tmp_type = Object.prototype.toString.call(settingobj.value_editAlias);
              let jsona = JSON.stringify(curdatas);
              let jsonb = jsona;

              let old_str = '/"'+settingobj.value+'"/g';
              if (tmp_type == '[object String]') {
                jsonb = jsonb.replace(eval(old_str),'"'+settingobj.value_editAlias+'"');
              } else if (tmp_type == '[object Array]') {
                for (let m = 0; m < settingobj.value_editAlias.length; m++) {
                  if (settingobj.value[m] == settingobj.value_editAlias[m]) {
                    continue;
                  }
                  old_str = '/"'+settingobj.value[m]+'"/g';
                  jsonb = jsonb.replace(eval(old_str),'"'+settingobj.value_editAlias[m]+'"');
                }
              }
              curdatas = JSON.parse(jsonb);
              data.data = curdatas
            }
        }*/
        return data
      }
      export function  replaceFilterOfModelChart (chart_cfg, keyFieldValue, word, dataid) {
        if (chart_cfg.chartfilter == undefined) {
          chart_cfg.chartfilter = []
        }
        chart_cfg.id = -1;
        for (let i = 0; i < keyFieldValue.length; i++) {
          let index_find = FindChartfilter(chart_cfg.chartfilter, 'name', keyFieldValue[i].field);
          if (index_find >= 0) {
            //找到了 进行替换
            let datatype = '';
            let value = keyFieldValue[i].value
            let one_charttFilter = chart_cfg.chartfilter[index_find];
            if (chart_cfg.chartfilter[index_find] && chart_cfg.chartfilter[index_find].datatype)
              datatype = chart_cfg.chartfilter[index_find].datatype;
            else
              datatype = 'varchar';
            
            let isNUmver = fieldIsnumber(datatype);
            if (isNUmver == 1) {
              one_charttFilter.hightype = 'high1';
              one_charttFilter.filtertype = 'high1';
              one_charttFilter.selectvalue = '2';
              one_charttFilter.filter = [{ "value": value, "opt": "$e" }];
              one_charttFilter.filterstr = '等于 ' + value;
            } else {
              one_charttFilter.hightype = 'normal';
              one_charttFilter.filtertype = 'normal';
              one_charttFilter.selectvalue = '1';
              one_charttFilter.filter = [value];
              one_charttFilter.filterstr = value;
            }
            chart_cfg.chartfilter[index_find] = one_charttFilter;
            //替换title
            chart_cfg.styleset = replaceTitleInTemple(chart_cfg.styleset, word);
          } else {
            //没有找到  
            let name = keyFieldValue[i].field
            let value = keyFieldValue[i].value
            let datatype = keyFieldValue[i].type
            if (datatype == undefined) {
              datatype = 'varchar';
            }
            let chartfilter = { "name": name, "displayName": name, "datatype": datatype, "datatypeEx": datatype, "filter": [value], "showfilter": false, "dataid": dataid, "isother": true, "hightype": "normal", "filtertype": "normal", "selectvalue": "1", "filterstr": value };
            chart_cfg.chartfilter.push(chartfilter);
            //替换title
            chart_cfg.styleset = replaceTitleInTemple(chart_cfg.styleset, word);
          }
        }//for 
        return chart_cfg;
      }
      //替换title
      export function  replaceTitleInTemple (styleset, word) {
        if (styleset == undefined) {
          styleset = {};
        }
        if (styleset.title == undefined) {
          styleset.title = { left: "center", show: true, text: "", textStyle: { color: "#333", fontSize: 18 }, top: 10 }
        }
        styleset.title.text = word;
      
        return styleset;
      }
      export function FindChartfilter (datas, propertyName, findValue) {
        let find_index = -1;
        let i = 0;
        if (datas) {
          for (i = 0; i < datas.length; i++) {
            if (datas[i][propertyName] == findValue) {
              find_index = i;
              break;
            }
          }
        }
        return find_index;
      }
      //数据源设置 ：处理数据DB和table
      export function dowithAllDBandTables (allData) {
        let i = 0;
        let dbs = [];
        let dbs_index = [];
        let tables = [];
        let db_tmp = '';
        let table_tmp = '';
        let find_index = -1;
        let sourceId = '';
        for (i = 0; i < allData.length; i++) {
          sourceId = allData[i].sourceId;
          db_tmp = allData[i].databaseName;
          table_tmp = allData[i].tableName;
          let dataSourceName = allData[i].dataSourceName;
          find_index = dbs_index.indexOf(sourceId);
          if (find_index > -1) {//有 
          } else {//没有
            //
            if (allData[i].databaseType == 'excel') {
              dbs.push({ sourceId: sourceId, databaseType: allData[i].databaseType, databaseName: allData[i].fileName, dataSourceName:dataSourceName});
            } else {
              dbs.push({ sourceId: sourceId, databaseType: allData[i].databaseType, databaseName: db_tmp, dataSourceName:dataSourceName});
            }
            dbs_index.push(sourceId);
            find_index = dbs.length - 1;
          }
          if (tables[find_index] == undefined) {
            tables[find_index] = [];
          }
          tables[find_index].push({ dataId: allData[i].dataId, tableName: table_tmp, databaseName: db_tmp, databaseType: allData[i].databaseType, nickName: allData[i].nickName, dbIndex: find_index });
        }//for i
        return { tables: tables, dbs: dbs }
      }
      //根据option和标注生成标注点
       export function setXaxisyAxis (option, params, mainaxis) {
        //params.seriesIndex
        // point = {name:params.markcontent,xAxis:params.dataIndex,yAxis: series_data[params.dataIndex],uuid:params.uuid}
        let one_series = option.series[params.seriesIndex];
        let xAxisIndex = 0;
        let yAxisIndex = 0;
        if (one_series.xAxisIndex) {
          xAxisIndex = one_series.xAxisIndex
        }
        if (one_series.yAxisIndex) {
          yAxisIndex = one_series.yAxisIndex
        }
        //判断x轴或Y轴的是值还是category  time
        let x_type = 'category';
        if (option.xAxis && option.xAxis[xAxisIndex] && (option.xAxis[xAxisIndex].type == 'value' || option.xAxis[xAxisIndex].type == 'log')) {
          x_type = 'value';
        }
        let y_type = 'value';
        if (option.yAxis && option.yAxis[yAxisIndex] && (option.yAxis[yAxisIndex].type == 'category' || option.yAxis[yAxisIndex].type == 'time')) {
          y_type = 'category';
        }
      
      let x_value = '';//params.dataIndex;
      let y_value = '';//都用值
      if(mainaxis == '' || mainaxis == 'xaxis') {
        x_value = params.dataIndex;
        if (x_type == 'value') {
          //用 值 不能用index   都用值
          if (one_series.data && one_series.data[params.dataIndex] && one_series.data[params.dataIndex][0]) {
            x_value = one_series.data[params.dataIndex][0]
          }
        } else if(x_type == 'category') {
          if (option.xAxis && option.xAxis[xAxisIndex] && option.xAxis[xAxisIndex].data) {
            x_value = option.xAxis[xAxisIndex].data[params.dataIndex];
          }
        }
        let tmp = one_series.data[params.dataIndex];
        if (Object.prototype.toString.call(tmp) == '[object Object]') {
          y_value = tmp.value
        } else if (Object.prototype.toString.call(tmp) == '[object Array]') {
          y_value = tmp[1]
        } else {
          y_value = tmp;
        }
      } else if (mainaxis == 'yaxis'){
        y_value = params.dataIndex;
        if (y_type == 'value') {
          //用 值 不能用index   都用值
          if (one_series.data && one_series.data[params.dataIndex] && one_series.data[params.dataIndex][1]) {
            y_value = one_series.data[params.dataIndex][1];
          }
        } else if(y_type == 'category') {
          if (option.yAxis && option.yAxis[yAxisIndex] && option.yAxis[yAxisIndex].data) {
            y_value = option.yAxis[yAxisIndex].data[params.dataIndex];
          }
        }
        let tmp = one_series.data[params.dataIndex];
        if (Object.prototype.toString.call(tmp) == '[object Object]') {
          x_value = tmp.value
        } else if (Object.prototype.toString.call(tmp) == '[object Array]') {
          x_value = tmp[0]
        } else {
          x_value = tmp;
        }
      }
      let point = { name: params.markcontent, xAxis: x_value, yAxis: y_value, uuid: params.uuid };
      return point;
      }
    ///option合并相关函数
    // 根据图表样式配置与数据库存储的已有的样式配置拟合为新的样式配置
    /*  发现没有用到 先注释掉 20210615 lili
     export function mergeCharttyleItems(curStyleItems, dbStyleItems) {
        // 两层  以curStyleItems为准，把数据库中存储的设置值增加到当前的设置中
        for (let key in curStyleItems) {
          //console.log(key + '---' + obj[key])
          if (dbStyleItems[key] !== undefined) {
            for (let key1 in curStyleItems[key]) {
              if (dbStyleItems[key][key1] !== undefined) {
                curStyleItems[key][key1] = dbStyleItems[key][key1]
              }
            }
          }
          else {//不处理
          }
        }
        return curStyleItems
      }*/
      // 把变量中的样式设置合并到图表的option中 用来渲染图
      /*
      export function merge2option (option, styleitem) {
        // title
        if (styleitem.title != undefined) {
          if (option.title == undefined)
            option.title = {}
          if (Object.prototype.toString.call(option.title) == '[object Object]') {
            option.title.show = styleitem.title.isshow.value
            option.title.text = styleitem.title.text.value
            if (option.title.textStyle == undefined)
              option.title.textStyle = {}
            option.title.textStyle.color = styleitem.title.color.value
            //  option.title.textStyle.fontFamily = styleitem.title.fontfamily.value
            option.title.textStyle.fontSize = styleitem.title.fontsize.value
            if (styleitem.title.aligntype == '居中') {
              option.title.left = 'center'
            } else if (styleitem.title.aligntype == '左对齐') {
              option.title.left = 'left'
            } else if (styleitem.title.aligntype == '右对齐') {
              option.title.left = 'right'
            }
          } else if (Object.prototype.toString.call(option.title) == '[object Array]') {
            option.title[0].show = styleitem.title.isshow.value
            option.title[0].text = styleitem.title.text.value
            if (option.title[0].textStyle == undefined)
              option.title[0].textStyle = {}
            option.title[0].textStyle.color = styleitem.title.color.value
            //  option.title[0].textStyle.fontFamily = styleitem.title.fontfamily.value
            option.title[0].textStyle.fontSize = styleitem.title.fontsize.value
            if (styleitem.title.aligntype.value == '居中') {
              option.title[0].left = 'center'
            } else if (styleitem.title.aligntype.value == '左对齐') {
              option.title[0].left = 'left'
            } else if (styleitem.title.aligntype.value == '右对齐') {
              option.title[0].left = 'right'
            }
          }
        }
        return option
      }*/
      export function  merge2optionNewTheme(option,huabustyles,maintype) {
        let theme = {};
        if(huabustyles && huabustyles.theme && huabustyles.theme.theme) {
          theme = JSON.parse(JSON.stringify(huabustyles.theme.theme));//copy的方式合并
        }

        if(option == undefined) {
          option = {};
        }
        let is_candlestick = 0;
        if(option && option.series && option.series[0]) {
          if(option.series[0].type == 'candlestick') {
            is_candlestick = 1;
          }
        }
        let model_type = 1;
        if(option && option.hlname) {//海量ADP自己的模型，例如 表格，切片器等
          model_type = 3
        }
        if(model_type == 3) {//合并背景 标题  label颜色
          //background-color
          option.theme = theme;
          if(theme.title && theme.title.textStyle && theme.title.textStyle.color) {
            option.theme.titleColor = theme.title.textStyle.color
          }
          if(theme.label && theme.label.color) {
            option.color = theme.label.color
          } else if(theme.label && theme.label.normal && theme.label.normal.textStyle && theme.label.normal.textStyle.color) {
            option.color = theme.label.color
          } else {
            if(theme.legend && theme.legend.textStyle && theme.legend.textStyle.color) {
              option.color = theme.legend.textStyle.color;
            }
          }
        } else {
          for(let key in theme) {
            //轴类型 categoryAxis   valueAxis  logAxis  timeAxis
            if(key == 'categoryAxis' || key == 'valueAxis' || key == 'logAxis' || key == 'timeAxis') {
              let xAxis = option.xAxis;
              if(Object.prototype.toString.call(xAxis) == '[object Array]') {
                for(let i = 0; i < xAxis.length; i++) {
                  if(is_candlestick == 1 && i >= 1) {
                      break;
                  }
                  let one_xAxis = xAxis[i];
                  let contrl_no = 0;
                  if(i > 0 && (one_xAxis.gridIndex == undefined || one_xAxis.gridIndex == 0 || one_xAxis.gridIndex == null)) {
                    //break;//在同一个grid中存在多个y轴，样式只合并第一个
                    contrl_no = 1;
                  }
                  if(one_xAxis.type == '' || one_xAxis.type == 'value') {
                    option.xAxis = mergeOneprototype(option['xAxis'], i, theme['valueAxis'], maintype, contrl_no);
                  } else if(one_xAxis.type == 'category') {
                    option.xAxis = mergeOneprototype(option['xAxis'], i, theme['categoryAxis'], maintype, contrl_no);
                  } else if(one_xAxis.type == 'log') {
                    option.xAxis = mergeOneprototype(option['xAxis'], i, theme['logAxis'], maintype, contrl_no);
                  } else if(one_xAxis.type == 'time') {
                    option.xAxis = mergeOneprototype(option['xAxis'], i, theme['timeAxis'], maintype, contrl_no);
                  }
                }
              } else if(Object.prototype.toString.call(xAxis) == '[object Object]') {
                if(xAxis.type == '' || xAxis.type == 'value') {
                  option = mergeOneprototype(option, 'xAxis', theme['valueAxis'], maintype);
                } else if(xAxis.type == 'category') {
                  option = mergeOneprototype(option, 'xAxis', theme['categoryAxis'], maintype);
                } else if(xAxis.type == 'log') {
                  option = mergeOneprototype(option, 'xAxis', theme['logAxis'], maintype);
                } else if(xAxis.type == 'time') {
                  option = mergeOneprototype(option, 'xAxis', theme['timeAxis'], maintype);
                }
              }

              let yAxis = option.yAxis;
              if(Object.prototype.toString.call(yAxis) == '[object Array]') {
                for(let i = 0; i < yAxis.length; i++) {
                  if(is_candlestick == 1 && i >= 1) {
                    break;
                  }
                  let one_yAxis = yAxis[i];
                  let contrl_no = 0;
                  if(i > 0 && (one_yAxis.gridIndex == undefined || one_yAxis.gridIndex == 0 || one_yAxis.gridIndex == null)) {
                    //break;//在同一个grid中存在多个y轴，样式只合并第一个
                    contrl_no = 1;
                  }
                  if(one_yAxis.type == '' || one_yAxis.type == 'value') {
                    option.yAxis = mergeOneprototype(option['yAxis'], i, theme['valueAxis'], maintype,contrl_no);
                  } else if(one_yAxis == 'category') {
                    option.yAxis = mergeOneprototype(option['yAxis'], i, theme['categoryAxis'], maintype,contrl_no);
                  } else if(one_yAxis == 'log') {
                    option.yAxis = mergeOneprototype(option['yAxis'], i, theme['logAxis'], maintype,contrl_no);
                  } else if(one_yAxis == 'time') {
                    option.yAxis = mergeOneprototype(option['yAxis'], i, theme['timeAxis'], maintype,contrl_no);
                  }
                }
              } else if(Object.prototype.toString.call(yAxis) == '[object Object]') {
                if(yAxis.type == '' || yAxis.type == 'value') {
                  option = mergeOneprototype(option, 'yAxis', theme['valueAxis'], maintype);
                } else if(yAxis.type == 'category') {
                  option = mergeOneprototype(option, 'yAxis', theme['categoryAxis'], maintype);
                } else if(yAxis.type == 'log') {
                  option = mergeOneprototype(option, 'yAxis', theme['logAxis'], maintype);
                } else if(yAxis.type == 'time') {
                  option = mergeOneprototype(option, 'yAxis', theme['timeAxis'], maintype);
                }
              }
            
            } else if(key == 'line' || key == 'radar' || key == 'bar' || key == 'pie' || key == 'scatter' || key == 'boxplot'
            || key=='parallel' || key=='sankey' || key=='funnel' || key=='gauge' || key=='candlestick' || key=='map' || key=='geo') {
              //图类型
            //line radar  bar  pie  scatter  boxplot  parallel  sankey  funnel  gauge  candlestick  graph  map geo
              let series = option.series;
              if(Object.prototype.toString.call(series) == '[object Object]') {
                if(series.type == key) {
                  option = mergeOneprototype(option, 'series', theme[key], maintype);
                }
              } else if(Object.prototype.toString.call(series) == '[object Array]') {
                for(let i = 0; i < series.length; i++) {
                  if(option['series'][i].type == key) {
                    option.series = mergeOneprototype(option.series, i, theme[key], maintype);
                  }
                }//for i
              }

            } else if(key =='graph') {//不合并

            } else if(key == 'label') {
              let series = option.series;
              if(Object.prototype.toString.call(series) == '[object Object]') {
                  option.series = mergeOneprototype(option.series, key, theme[key], maintype);
              } else if(Object.prototype.toString.call(series) == '[object Array]') {
                for(let i = 0; i < series.length; i++) {
                  if(option['series'][i].type == key) {
                    option.series[i] = mergeOneprototype(option.series[i], key, theme[key], maintype);
                  }
                }//for i
              }
            } else {
              //其他合并到option中
              if(option[key] != undefined) {
                option = mergeOneprototype(option, key, theme[key], maintype);
              } else if(key == 'backgroundColor' || key == 'color') {
                option[key] =  theme[key];
              }
            }
          } 
        }
        return option
      }
      // 把变量中的样式设置合并到图表的option中 用来渲染图
      export function  merge2option (option, styleitem, huabustyles, maintype) {

        //先判断huabustyles中是否有 视觉优化的结果
        ////0智能优化的颜色优先 1保持手动配置颜色优先
        let priority = 0
        let all_dimensions = [];
        let colors = [];//主题颜色
        if (huabustyles) {
          if (huabustyles.aisetting) {
            //colorsetting  dimensions   types   priority
            priority = huabustyles.aisetting.priority * 1
            if (priority == undefined) {
              priority = 0
            }
            all_dimensions = huabustyles.aisetting.dimensions
            if (all_dimensions == undefined) {
              all_dimensions = []
            }
          }
          if (huabustyles.theme) {//老版本主题色
            if (huabustyles.theme.color) {
              colors = huabustyles.theme.color
            }
            //新版本主题色
            if(huabustyles.theme.theme && huabustyles.theme.theme.color) {
              colors = huabustyles.theme.theme.color;
            }
          }
      }
      //新版本主题色设置
      if(huabustyles && huabustyles.theme && huabustyles.theme.theme && huabustyles.theme.ver == 2) {//新主题的颜色在最初进行合并，手工设置的优先
        option = merge2optionNewTheme(option,huabustyles,maintype);//使用新版本的主题，兼容echarts的的主题
      }
      
        let zuobiaoxi = getZuobiaoInfo(option)
        if (priority == 0) {
          option = merge2optionFromManual(option, styleitem, maintype)

          option = merge2optionFromVisaulOpt(option, huabustyles, zuobiaoxi)
          if (all_dimensions.length > 0 && colors.length > 0) {
            if (zuobiaoxi == 1) {
              option = setDimensionsofXYaxis(all_dimensions, colors, option)
            } else if (zuobiaoxi == 0) {
              option = setDimensionsofNoaxis(all_dimensions, colors, option)
            }
          }

        } else if (priority == 1) {
          option = merge2optionFromVisaulOpt(option, huabustyles, zuobiaoxi)
          if (all_dimensions.length > 0 && colors.length > 0) {
            if (zuobiaoxi == 1) {
              option = setDimensionsofXYaxis(all_dimensions, colors, option)
            } else if (zuobiaoxi == 0) {
              option = setDimensionsofNoaxis(all_dimensions, colors, option)
            }
          }

          option = merge2optionFromManual(option, styleitem, maintype)
        } else {
          option = merge2optionFromManual(option, styleitem, maintype)
        }
        //检查是否需要设置主题颜色  老版本主题色
        if (huabustyles) {
          if (huabustyles.theme) {
            if (huabustyles.theme.color) {
              if (huabustyles.theme.color.length > 3) {
                if (option)
                  option.color = huabustyles.theme.color
              }
            }
          }
        }
        //
        return option;
      }
      //合并 视觉优化 设置到option
      export function  merge2optionFromVisaulOpt (option, huabustyles, zuobiaoxi) {
        let allColorsetting = {}
        if (huabustyles) {
          if (huabustyles.aisetting) {
            allColorsetting = huabustyles.aisetting.colorsetting
          }
        }
        option = mergeColorsetting2Option(option, zuobiaoxi, allColorsetting);
        return option
      }
      //合并手动配置
      export function merge2optionFromManual (option, styleitem, maintype) {
        for (let key in styleitem) {
          if (key == 'title') {
            if (Object.prototype.toString.call(styleitem.title.isshow) == '[object Object]') {
              //老版本title
              option = mergeoldtitle(option, styleitem, maintype)
            } else {
              option = mergeOneprototype(option, key, styleitem[key], maintype)
            }
          } else if (key == 'xdataZoom' || key == 'ydataZoom') {
            option = mergeslider(option, styleitem, key, maintype)
          } else if (key == 'datacolor') {
            //数据颜色的合并
            option = mergedatacolor(option, styleitem, maintype)
          } else if (key == 'datalabel') {
            option = mergedatalabel(option, styleitem, maintype)
          } else if (key == 'clouddata') {
            option = mergeclouddata(option, styleitem, maintype)
          } else if (key == 'graphnodes') {
            option = mergeGraphnodes(option, styleitem, maintype)
          } else if (key == 'graphlinks') {
            option = mergeGraphlinks(option, styleitem, maintype)
          } else if (key == 'radarfillcolor') {
            mergeOneprototype(option, 'series', styleitem[key], maintype)
          } else if (key == 'grid') {
            //如果是多个grid 直角多个grid不能直接合并
            let cur_grid = option.grid
            let cur_grid_type = Object.prototype.toString.call(cur_grid);
            let gridcnt = 0
            if (cur_grid_type == '[object Object]') {
              gridcnt = 1
            } else if (cur_grid_type == '[object Array]') {
              gridcnt = cur_grid.length
            }
            if (gridcnt > 1) {
              //特殊合并
              option = mergeOneprototype_grid(option, key, styleitem[key], maintype)
            } else {//没有或只有1个  直接合并
              option = mergeOneprototype(option, key, styleitem[key], maintype)
            }
          } else {
            option = mergeOneprototype(option, key, styleitem[key], maintype)
          }
        }
        return option
      }
      //关系图合并 --节点配置
      export function mergeGraphnodes (option, styleitem, maintype) {
        if (option.series) {
          option = mergeOneprototype(option, 'series', styleitem['graphnodes'], maintype)
        }
        return option
      }
      //关系图合并 --关系配置
      export function mergeGraphlinks(option, styleitem, maintype) {
        if (option.series) {
          option = mergeOneprototype(option, 'series', styleitem['graphlinks'], maintype)
        }
        return option
      }
      //词云图数据项的配置合并
     export function  mergeclouddata (option, styleitem, maintype) {
        if (option.series) {
          option = mergeOneprototype(option, 'series', styleitem['clouddata'], maintype)
        }
        return option
      }
      //数据标签的合并
      export function mergedatalabel(option, styleitem, maintype) {
        if (option.series) {
          if (Object.prototype.toString.call(option.series) == '[object Object]') {
            if (option.series.label == undefined) {
              option.series.label = {}
            }
            //对数据标签的显示格式进行特殊处理
            let f_type = Object.prototype.toString.call(option.series.label.formatter)    ///[object Function]
            let label_func = undefined
            if (f_type == '[object Function]') {
              label_func = option.series.label.formatter
              let tmp_styleitem = JSON.parse(JSON.stringify(styleitem['datalabel']))
              let ftmp = tmp_styleitem.formatter
              if (tmp_styleitem.color == '') {
                delete tmp_styleitem.color;
              }
              option.series.label = tmp_styleitem
              option.series.label.formatter = label_func
              if (ftmp != undefined) {
                option.series.label.adp_formatter = ftmp;
              }
            } else {
              let minAngle = undefined;
              if (option.series.label && option.series.label.minAngle) {
                minAngle = option.series.label.minAngle;
              }
              option.series.label = JSON.parse(JSON.stringify(styleitem['datalabel']));
              if (minAngle) {
                option.series.label.minAngle = minAngle;
              }
            }
            if (option.series.type == 'line') {
              if (option.series.label.show == true)
                option.series.symbol = 'emptyCircle'
              else
                option.series.symbol = 'none'
            } else if (option.series.type == 'pie') {
              if (option.series.label.show == true) {
                if (option.series.labelLine) {
                  option.series.labelLine.show = true
                } else {
                  option.series.labelLine = { show: true }
                }
              }
            }
          } else if (Object.prototype.toString.call(option.series) == '[object Array]') {
            let label_func = undefined
            for (let m = 0; m < option.series.length; m++) {
              //对数据标签的显示格式进行特殊处理
              let f_type = ''
              if (option.series[m] && option.series[m].label)
                f_type = Object.prototype.toString.call(option.series[m].label.formatter)    ///[object Function]
              if (f_type == '[object Function]') {
                label_func = option.series[m].label.formatter
                let tmp_styleitem = JSON.parse(JSON.stringify(styleitem['datalabel']))
                let ftmp = tmp_styleitem.formatter
                if (ftmp != undefined) {
                  tmp_styleitem.adp_formatter = ftmp;
                } else {
                  if (option.series[m].label.adp_formatter) {
                    tmp_styleitem.adp_formatter = option.series[m].label.adp_formatter;
                  }
                }
                
                if (tmp_styleitem.color == '') {
                  delete tmp_styleitem.color;
                }
                option.series[m].label = tmp_styleitem
                option.series[m].label.formatter = label_func
              } else {
                let minAngle = undefined;
                if (option.series[m].label && option.series[m].label.minAngle) {
                  minAngle = option.series[m].label.minAngle;
                }
                option.series[m].label = JSON.parse(JSON.stringify(styleitem['datalabel']));
                option.series[m].label.minAngle = minAngle;
              }
              // option.series[m].label = styleitem['datalabel']
              if (option.series[m].type == 'line') {
                if (option.series[m].label.show == true) {
                  option.series[m].symbol = 'emptyCircle'
                  option.series[m].showSymbol = true;
                } else {
                  option.series[m].symbol = 'none';
                  option.series[m].showSymbol = false;
                }
              } else if (option.series[m].type == 'pie') {
                if (option.series[m].label.show == true) {
                  if (option.series[m].labelLine) {
                    option.series[m].labelLine.show = true
                  } else {
                    option.series[m].labelLine = { show: true }
                  }
                }
              }
            }
          }
        }
        return option
      }
      //数据颜色的合并
      export function mergedatacolor (option, styleitem, maintype) {

        let datacolor = []
        let details = []
        if (Object.prototype.toString.call(styleitem['datacolor']) == '[object Array]') {
          datacolor = styleitem['datacolor']
        } else if (Object.prototype.toString.call(styleitem['datacolor']) == '[object Object]') {
          datacolor = styleitem['datacolor'].default
          details = styleitem['datacolor'].details
        }
        let dataname = datacolor.map(function (item) { return item.name })
        let zuobiaoxi = getZuobiaoInfo(option)
        if (zuobiaoxi == 0 || zuobiaoxi == 4) {
          if (Object.prototype.toString.call(option.series) == '[object Object]') {
            for (let m = 0; m < option.series.data.length; m++) {
              let myFirstIndex = dataname.indexOf(option.series.data[m].name)
              if (myFirstIndex >= 0) {
                if (option.series.data[m].itemStyle == undefined)
                  option.series.data[m].itemStyle = { color: '' }
                option.series.data[m].itemStyle.color = datacolor[myFirstIndex].color
              } else {
                if (option.series.data[m].itemStyle)
                  delete option.series.data[m].itemStyle.color
              }
            }
          } else if (Object.prototype.toString.call(option.series) == '[object Array]') {
            for (let n = 0; n < option.series.length; n++) {
              for (let m = 0; m < option.series[n].data.length; m++) {
                let myFirstIndex = dataname.indexOf(option.series[n].data[m].name)
                if (myFirstIndex >= 0) {
                  if (option.series[n].data[m].itemStyle == undefined)
                    option.series[n].data[m].itemStyle = { color: '' }
                  option.series[n].data[m].itemStyle.color = datacolor[myFirstIndex].color
                } else {
                  if (option.series[n].data[m] && option.series[n].data[m].itemStyle)
                    delete option.series[n].data[m].itemStyle.color
                }
              }
            }// for n
          }
        } else if (zuobiaoxi == 1) {
          //直角坐标系
          if (Object.prototype.toString.call(option.series) == '[object Object]') {
            let myFirstIndex = -1
            let findname = ''
            if (option.series.name != undefined)
              findname = option.series.name
            myFirstIndex = dataname.indexOf(findname)
            if (myFirstIndex >= 0) {
              option.series.color = datacolor[myFirstIndex].color
            } else {
              delete option.series.color
            }
            //条形图
            if (details) {
              if (details.length > 0) {
                let ydata = []
                if (Object.prototype.toString.call(option.yAxis) == '[object Object]') {
                  ydata = option.yAxis.data
                } else if (Object.prototype.toString.call(option.yAxis) == '[object Array]') {
                  ydata = option.yAxis[0].data
                }
                let myindex = -1
                for (let mm = 0; mm < details.length; mm++) {
                  myindex = ydata.indexOf(details[mm].name)
                  if (myindex >= 0) {
                    let value = ''
                    if (Object.prototype.toString.call(option.series.data[myindex]) == '[object Object]') {
                      value = option.series.data[myindex].value
                    } else
                      value = option.series.data[myindex]
                    option.series.data[myindex] = { value: value, itemStyle: { color: details[mm].color } }
                  } else {
                    if (Object.prototype.toString.call(option.series.data[myindex]) == '[object Object]') {
                      if (option.series.data[myindex].itemStyle) {
                        delete option.series.data[myindex].itemStyle.color
                      }
                    } else {
                      //不处理，说明没有设置颜色
                    }
                  }
                }// mm
              }
            }
          } else if (Object.prototype.toString.call(option.series) == '[object Array]') {
            for (let n = 0; n < option.series.length; n++) {
              let findname = ''
              if (option.series[n].name != undefined)
                findname = option.series[n].name
              let myFirstIndex = dataname.indexOf(findname)
              if (myFirstIndex >= 0) {
                option.series[n].color = datacolor[myFirstIndex].color
              } else {
                delete option.series[n].color
              }
            }// for n
            //条形图
            if (details) {
              if (details.length > 0) {
                let ydata = []
                if (Object.prototype.toString.call(option.yAxis) == '[object Object]') {
                  ydata = option.yAxis.data
                } else if (Object.prototype.toString.call(option.yAxis) == '[object Array]') {
                  ydata = option.yAxis[0].data
                }
                let myindex = -1
                for (let mm = 0; mm < details.length; mm++) {
                  myindex = ydata.indexOf(details[mm].name)
                  if (myindex >= 0) {
                    let value = ''
                    if (Object.prototype.toString.call(option.series[0].data[myindex]) == '[object Object]') {
                      value = option.series[0].data[myindex].value
                    } else
                      value = option.series[0].data[myindex]
                    option.series[0].data[myindex] = { value: value, itemStyle: { color: details[mm].color } }
                  } else {
                    if (Object.prototype.toString.call(option.series[0].data[myindex]) == '[object Object]') {
                      if (option.series[0].data[myindex].itemStyle) {
                        delete option.series[0].data[myindex].itemStyle.color
                      }
                    } else {
                      //不处理 说明没有颜色
                    }
                  }
                }// mm
              } else {
                //没有设置  把以前设置过的删除掉
                if (Object.prototype.toString.call(option.series) == '[object Object]') {
                  if (option.series.data) {
                    let data_index = 0
                    for (data_index = 0; data_index < option.series.data.length; data_index++) {
                      if (option.series.data[data_index].itemStyle && option.series.data[data_index].itemStyle.color) {
                        delete option.series.data[data_index].itemStyle.color
                      }
                    }
                  }
                } else if (Object.prototype.toString.call(option.series) == '[object Array]') {
                  let s_index = 0;
                  for (s_index = 0; s_index < option.series.length; s_index++) {
                    if (option.series[s_index].data) {
                      let dd = 0;
                      for (dd = 0; dd < option.series[s_index].data.length; dd++) {
                        if (option.series[s_index].data[dd] == null) {
                          option.series[s_index].data[dd] = 0;
                        }
                        if (option.series[s_index].data[dd].itemStyle && option.series[s_index].data[dd].itemStyle.color) {
                          delete option.series[s_index].data[dd].itemStyle.color
                        }
                      }//for dd
                    }
                  }//s_index
                }
              }
            }
          }
        }
        return option
      }
      //老版本title的合并
      export function  mergeoldtitle(option, styleitem, maintype) {
        if (option.title == undefined)
          option.title = {}
        if (Object.prototype.toString.call(option.title) == '[object Object]') {
          option.title.show = styleitem.title.isshow.value
          option.title.text = styleitem.title.text.value
          if (option.title.textStyle == undefined)
            option.title.textStyle = {}
          option.title.textStyle.color = styleitem.title.color.value
          //  option.title.textStyle.fontFamily = styleitem.title.fontfamily.value
          option.title.textStyle.fontSize = styleitem.title.fontsize.value
          if (styleitem.title.aligntype == '居中') {
            option.title.left = 'center'
          } else if (styleitem.title.aligntype == '左对齐') {
            option.title.left = 'left'
          } else if (styleitem.title.aligntype == '右对齐') {
            option.title.left = 'right'
          }
        } else if (Object.prototype.toString.call(option.title) == '[object Array]') {
          option.title[0].show = styleitem.title.isshow.value
          option.title[0].text = styleitem.title.text.value
          if (option.title[0].textStyle == undefined)
            option.title[0].textStyle = {}
          option.title[0].textStyle.color = styleitem.title.color.value
          //  option.title[0].textStyle.fontFamily = styleitem.title.fontfamily.value
          option.title[0].textStyle.fontSize = styleitem.title.fontsize.value
          if (styleitem.title.aligntype.value == '居中') {
            option.title[0].left = 'center'
          } else if (styleitem.title.aligntype.value == '左对齐') {
            option.title[0].left = 'left'
          } else if (styleitem.title.aligntype.value == '右对齐') {
            option.title[0].left = 'right'
          }
        }
        return option
      }
      //滑杆的设置合并
      export function mergeslider (option, styleitem, key, maintype) {
        if (option.dataZoom == undefined) {
          option.dataZoom = [{ show: false }, { show: false }]
        }
        if (option.dataZoom.length == 0) {
          option.dataZoom = [{ show: false }, { show: false }]
        }
        if (option.dataZoom.length == 1) {
          option.dataZoom.push({ show: false })
        }
        if (key == 'xdataZoom') {
          let xlen = -1
          if (option.xAxis) {
            if (Object.prototype.toString.call(option.xAxis) == '[object Array]') {
              xlen = option.xAxis.length
            } else if (Object.prototype.toString.call(option.xAxis) == '[object Object]') {
              xlen = 1
            }
          }
          option.dataZoom[0] = styleitem[key]
          if (xlen >= 0) {
            option.dataZoom[0].xAxisIndex = []
            for (let mm = 0; mm < xlen; mm++) {
              option.dataZoom[0].xAxisIndex.push(mm)
            }// mm
          }
        }
        if (key == 'ydataZoom') {
          let ylen = -1
          if (option.yAxis) {
            if (Object.prototype.toString.call(option.yAxis) == '[object Array]') {
              ylen = option.xAxis.length
            } else if (Object.prototype.toString.call(option.yAxis) == '[object Object]') {
              ylen = 1
            }
          }

          option.dataZoom[1] = styleitem[key]
          if (ylen >= 0) {
            option.dataZoom[1].yAxisIndex = []
            for (let mm = 0; mm < ylen; mm++) {
              option.dataZoom[1].yAxisIndex.push(mm)
            }// mm
          }
        }
        return option
      }
      //grid的特殊合并  grid是多个的情况   
      export function mergeOneprototype_grid (option, key, value, maintype) {
        //所有grid的设置相同的时候才合并，否则不合并
        ///value.top
        let grids = option.grid
        let top = ''
        let bottom = ''
        let left = ''
        let right = ''
        let width = ''
        let height = ''
        let grid_cnt = grids.length
        let isSame = 1
        for (let i = 0; i < grid_cnt; i++) {
          if (i == 0) {
            top = grids[i].top
            bottom = grids[i].bottom
            left = grids[i].left
            right = grids[i].right
            width = grids[i].width
            height = grids[i].height
          } else {
            if (grids[i].top == top && grids[i].bottom == bottom && grids[i].left == left && grids[i].right == right && grids[i].width == width && grids[i].height == height) {
              continue
            } else {
              isSame = 0
              break
            }
          }
        }
        //grid都重合 ，进行设置
        if (isSame == 1) {
          for (let i = 0; i < grid_cnt; i++) {
            option.grid.left = value.left
            option.grid.right = value.right
            option.grid.bottom = value.bottom
            option.grid.top = value.top
          }
        }
        return option
      }
      //合并一个属性值
      // maintype:1表示已option为主，向option合并   2表示已value为主，value覆盖原有option
      //contrlNomerge 控制类的是否合并
      export function mergeOneprototype (option, key, value, maintype,contrlNomerge) {
        if (option[key] == undefined) {
          option[key] = value
        } else {
          // if()
          if (Object.prototype.toString.call(option[key]) == '[object Object]') {
            if (Object.prototype.toString.call(value) == '[object String]' || Object.prototype.toString.call(value) == '[object Number]') {
              option[key] = value
            } else if (Object.prototype.toString.call(value) == '[object Object]') {
              //对象 和 对象 单个赋值
              for (let key1 in value) {
                if (key1.indexOf('#') > -1) {
                  let kk = key1.substring(1, key1.length)
                  option[key] = mergeOneprototype(option[key], kk, value[key1], maintype,contrlNomerge)
                } else {
                  option[key] = mergeOneprototype(option[key], key1, value[key1], maintype,contrlNomerge)
                }
              }
            } else if (Object.prototype.toString.call(value) == '[object Array]') {
              option[key] = value
            }
          } else if (Object.prototype.toString.call(option[key]) == '[object Array]') {
            if (Object.prototype.toString.call(value) == '[object Array]') {
              //option[key] = value
              //再下一层
              if (maintype == 1) {
                let m = 0;
                for (m = 0; m < value.length; m++) {
                  option[key] = mergeOneprototype(option[key], m, value[m], maintype,contrlNomerge)
                }
              } else {//maintype=2
                if(contrlNomerge == 1 && key == 'show') {
                  //不合并
                } else {
                  option[key] = value
                }
              }
            } else if (Object.prototype.toString.call(value) == '[object Object]') {
              let subkeys = Object.keys(value)
              let isHaveJing = 0 //# 井号
              let isXing = 0  //*
              for (let m = 0; m < subkeys.length; m++) {
                if (subkeys[m].indexOf('#') > -1) {
                  isHaveJing = 1;
                  break;
                }
                if (subkeys[m] == '*') {
                  isXing = 1;
                  break;
                }
              }
              let isNumber = 0
              if (subkeys[0] == '' || subkeys[0] == undefined) {
                isNumber = 0
              } else if (!isNaN(subkeys[0])) {
                isNumber = 1
              }

              if (isHaveJing == 1) {
                for (let m = 0; m < subkeys.length; m++) {
                  let key_tmp = subkeys[m]
                  let key_tmp1 = key_tmp;
                  if (key_tmp1.indexOf('#') > -1)
                    key_tmp1 = key_tmp.substring(1, key_tmp.length)
                  option[key] = mergeOneprototype(option[key], key_tmp1, value[key_tmp], maintype,contrlNomerge)
                }
              } else if (isXing == 1) {
                //下层第一个key是*
                let m = 0;
                let temp_value = value['*']
                for (m = 0; m < option[key].length; m++) {
                  option[key] = mergeOneprototype(option[key], m, temp_value, maintype,contrlNomerge)
                }//for m

              } else {
                if (isNumber == 1) {
                  for (let m = 0; m < subkeys.length; m++) {
                    let key_tmp = subkeys[m]
                    option[key] = mergeOneprototype(option[key], key_tmp, value[key_tmp], maintype,contrlNomerge)
                  }
                } else {
                  for (let i = 0; i < option[key].length; i++) {
                    option[key] = mergeOneprototype(option[key], i, value, maintype,contrlNomerge);
                    if(key == 'title') {
                      break;//只处理第一个
                    }
                  }// for i
                }
              }
            } else if (Object.prototype.toString.call(value) == '[object String]' || Object.prototype.toString.call(value) == '[object Number]') {
              for (let i = 0; i < option[key].length; i++) {
                option[key] = mergeOneprototype(option[key], i, value, maintype,contrlNomerge)
              }// for i
            }
          } else {
            //字符串或数值  object String   object Number
            if(contrlNomerge == 1 && key == 'show') {

            } else {
              option[key] = value
            }
          }
        }
        return option
      }
      //设计图形-视觉优化结果合并
      export function mergeOneSmodelOfAI(objoption,style,allColorsetting,priority) {
        let total_style = {}
        if(priority==0) {
          total_style = merge2option(total_style,style,{},1);
          if(allColorsetting.title != undefined) {
            let tmp = {'title':JSON.parse(JSON.stringify(allColorsetting.title))};
            tmp.color = tmp.title.textStyle.color;
            total_style = merge2option(total_style,tmp,{},1);
          }
        } else if(priority == 1) {
          if(allColorsetting.title != undefined) {
            let tmp = {'title':JSON.parse(JSON.stringify(allColorsetting.title))};
            tmp.color = tmp.title.textStyle.color;
            total_style = merge2option(total_style,tmp,{},1);
          }
          total_style = merge2option(total_style,style,{},1);
        }
        objoption = merge2option(objoption,total_style,{},1);
        return objoption;
      }
      export function fieldIsnumber(fieldtype) {
        if (fieldtype === 'int' || fieldtype === 'bigint' || fieldtype === 'float' || fieldtype === 'double' ||
          fieldtype === 'tinyint' || fieldtype === 'decimal' || fieldtype === 'smallint' || fieldtype === 'mediumint'
          || fieldtype == 'long') {
          return 1
        } else {
          return 0
        }
      }
      export function fieldIsChar(fieldtype) {
        if (fieldtype === 'varchar' || fieldtype === 'char' || fieldtype === 'tinytext' || fieldtype === 'text' ||
          fieldtype === 'mediumtext' || fieldtype === 'longtext' || fieldtype === 'enum') {
          return 1
        } else {
          return 0
        }
      }
      export function fieldIsDatetime(fieldtype) {
        if (fieldtype === 'date' || fieldtype === 'time' || fieldtype === 'datetime' || fieldtype === 'year' ||
          fieldtype === 'timestamp' ) {
          return 1
        } else {
          return 0
        }
    }
      // -1未知  0 无坐标系  1 直角  2 单轴  3 极坐标  4 雷达坐标 5 地理坐标 6 日历坐标  7 平行坐标  8关系类图
      export function getZuobiaoInfo(optionobj) {
        var ret = -1
        // 直角坐标系  有x轴 有y轴
        let isHavexAxis = 0
        let isHaveyAxis = 0
        let isHaveangleAxis = 0
        let isHaveradiusAxis = 0
        let isHavesingleAxis = 0
        for (var key in optionobj) {
          if (key === 'xAxis') {
            isHavexAxis = 1
            if (isHaveyAxis === 1) {
              return 1
            }
          } else if (key === 'yAxis') {
            isHaveyAxis = 1
            if (isHavexAxis === 1) {
              return 1
            }
          } else if (key === 'singleAxis') {
            isHavesingleAxis = 1
            // return 2
          } else if (key === 'radiusAxis') {
            isHaveradiusAxis = 1
            if (isHaveangleAxis === 1) {
              return 3
            }
          } else if (key === 'angleAxis') {
            isHaveangleAxis = 1
            if (isHaveradiusAxis === 1) {
              return 3
            }
          } else if (key === 'radar') {
            return 4
          } else if (key === 'geo' || key === 'bmap') {
            return 5
          } else if (key === 'calendar') {
            return 6
          } else if (key === 'parallelAxis' || key === 'parallel') {
            return 7
          }
        } // for
        if (isHavesingleAxis == 1) {
          ret = 2
        }
        if (ret === -1) {
          ret = 0
        }
        return ret
}
      //去除掉矩形树图中echars自己添加的leves 否则改变颜色时图不变色
   export function clearLevesInTreemap(option) {
    if(option) {
      if(option.series) {
        if(Object.prototype.toString.call(option.series) == '[object Object]') {
          if(option.series.levels) {
            if(option.series.levels.color) {
              delete option.series.levels.color
            } else if(option.series.levels[0] && option.series.levels[0].color) {
             delete option.series.levels[0].color
            }
          }
        } else if(Object.prototype.toString.call(option.series) == '[object Array]') {
          let m = 0;
          for(m = 0; m < option.series.length; m++) {
            if(option.series[m].levels) {
              if(option.series[m].levels.color) {
               delete option.series[m].levels.color
              } else if(option.series[m].levels[0] && option.series[m].levels[0].color) {
               delete option.series[m].levels[0].color
              }
            }
          }
        }
      }
    }
    return option
  }
  //检查List的配置中 原来配置了刷新某图，后改为不刷新或刷新其他的图，此情况返回图的id   否则返回-1
export function checkIsRefreshOther(oldStyle, params) {
  let ret = -1;
  if (oldStyle && oldStyle.isRoll == true && oldStyle.linkid && oldStyle.linkfield) {
    ret = oldStyle.linkid;
  }
  if (params && params.isRoll == true && params.linkid && params.linkfield && oldStyle.linkid==params.linkid) {
    ret = -1;
  }
  return ret;
}
export function parseScripte2optionnew(option, scriptes) {
      let echarts = require('echarts/lib/echarts') //此行代码有用，请勿删除
        for (var m = 0; m < scriptes.length; m++) {
          var path = scriptes[m].path;
          let type = scriptes[m].type;
          if (type && type * 1 == 3) {
            continue;
          }
          var paths = path.split(".")
          var content = ''
          var js_json = ''
          if (paths.length <= 0) {
            //什么都不做
          } else if (paths.length == 1) {
            content = scriptes[m].scripte
            js_json = eval('(' + content + ')');
            option[paths[0]] = js_json
          } else if (paths.length == 2) {
            content = scriptes[m].scripte
            js_json = eval('(' + content + ')');
            if (option[paths[0]] == undefined) {
              option[paths[0]] = {}
              option[paths[0]][paths[1]] = js_json
            } else {
              option[paths[0]][paths[1]] = js_json
            }
          } else {
            content = scriptes[m].scripte
            js_json = eval('(' + content + ')');

            var maxdeepth = paths.length - 1
            var curobj = option[paths[0]]
            var deepth = 1
            curobj = setoptionpath(option, curobj, paths, deepth, maxdeepth, js_json)
            option[paths[0]] = curobj
          }
      }// for m
      
      for (var m = 0; m < scriptes.length; m++) {
        let name = scriptes[m].path;
        let type = scriptes[m].type;
        if (type && type * 1 == 3) {
          let content = scriptes[m].scripte;
          eval(name+"(option);"+content);
        }
      }
      return option;
      }
  export function setoptionpath(option, curobj, paths, deepth, maxdeepth, js_json) {
        var mykey = paths[deepth]
      if (curobj == undefined) {
        curobj = {}
      } else {
        if (Object.prototype.toString.call(curobj) == "[object Array]") {
          if (curobj.length == 0 && paths && paths[deepth + 1] != '*') {
            curobj = {};
          }
        }
      }
        if (deepth == maxdeepth) {
          if(mykey == 'formatter' && curobj[mykey] != undefined && Object.prototype.toString.call(curobj[mykey])=='[object String]') {
              curobj['adp_formatter'] = curobj[mykey];
          }
          curobj[mykey] = js_json
        } else {
          if (mykey == '*') {
            for (var k = 0; k < curobj.length; k++) {
              curobj[k] = setoptionpath(option, curobj[k], paths, deepth + 1, maxdeepth, js_json);
            }
          } else {
            if(mykey == 'formatter' && curobj[mykey] != undefined && Object.prototype.toString.call(curobj[mykey])=='[object String]') {
              curobj['adp_formatter'] = curobj[mykey];
             } //adp_
            curobj[mykey] = setoptionpath(option, curobj[mykey], paths, deepth + 1, maxdeepth, js_json);
          }
        }
        return curobj
}
  //排序函数，特殊排序。不能通过数据库排序，前端制作的特殊排序  特殊函数排序
//堆积柱状图按照单个柱的大小排序，按照单个住占比排序 sortclass=2时执行此排序  其他值时以前的排序
export function dowithSortEx(setting,option,curdata) {
  let sorttype = setting.sorttype;
  if (sorttype == undefined || sorttype == '') {
    sorttype = 'asc';
  }
  if (setting.sortclass==2 && setting.sortspecial) {
    let sortspecial = setting.sortspecial;
    if (sortspecial.classtype == 'proportion') {//占比排序  
      //在所有series数据中的占比
      let allValues = caclTotalValues(option);//每组在x轴或y轴上的占比  有几个x轴数据就有几个值
      if (allValues.length > 0) {
        let seriesName4Sort = sortspecial.name;
        let perValues = caclPerValues(option, allValues, seriesName4Sort);
        //排序
        if (setting.mainaxis == 'yaxis') {
          if (sorttype == 'asc') {
            sorttype = 'desc';
          } else if (sorttype == 'desc') {
            sorttype = 'asc';
          }
        }
        perValues = sort_data_2value(perValues, 'value', 'orgValue', sorttype);
        //根据数组对series和x轴或y轴数据进行排序
        option = sortSeriesAndAxis(perValues,option,setting);
      }
    }
  }
  return {option:option,curdata:curdata};
}

export function sort_data_2value(curdata, sort_field1, sort_field2, sorttype) {
  if (curdata) {
    if (sorttype == 'asc') {
      curdata.sort(function (a, b) {
        if (a!=undefined && a[sort_field1]!=undefined && b!=undefined && b[sort_field1]!=undefined) {
          if (a[sort_field1] < b[sort_field1]) {
            return -1;
          } else if (a[sort_field1] == b[sort_field1]) {
            if (a[sort_field2] != undefined && b[sort_field2] != undefined) {
              if (a[sort_field2] < b[sort_field2]) {
                return -1;
              } else if (a[sort_field2] == b[sort_field2]) {
                return 0;
              } else {
                return 1;
              }
            }
          } else {
            return 1;
          }
        } else {
          return 0;
        }
      });
    } else {//desc
      curdata.sort(function (a, b) {
      if (a!=undefined && a[sort_field1]!=undefined && b!=undefined && b[sort_field1]!=undefined) {
        if (a[sort_field1] < b[sort_field1]) {
          return 1;
        } else if (a[sort_field1] == b[sort_field1]) {
          if (a[sort_field2] != undefined && b[sort_field2] != undefined) {
            if (a[sort_field2] < b[sort_field2]) {
              return 1;
            } else if (a[sort_field2] == b[sort_field2]) {
              return 0;
            } else {
              return -1;
            }
          }
        } else {
          return -1;
        }
      } else {
        return 0;
      }
    });
    }
  }
  return curdata;
}
//根据已经拍好序的数组 对option中轴数据和series中的数据进行排序  sortValues中每个元素的格式为{value:22,myindex:1}
export function sortSeriesAndAxis(sortValues,option,setting) {
  let axis_data = [];
  let axis_type = '';
  if (setting.mainaxis == 'xaxis') {
    if (option && option.xAxis) {
      axis_type = Object.prototype.toString.call(option.xAxis);
      if (axis_type == '[object Object]') {
        axis_data = option.xAxis.data;
      } else if (axis_type == '[object Array]') {
        if (option.xAxis.length > 0) {
          axis_data = option.xAxis[0].data;
        }
      }
    }
  } else if (setting.mainaxis == 'yaxis') {
    if (option && option.yAxis) {
      axis_type = Object.prototype.toString.call(option.xAxis);
      if (axis_type == '[object Object]') {
        axis_data = option.yAxis.data;
      } else if (axis_type == '[object Array]') {
        if (option.yAxis.length > 0) {
         axis_data = option.yAxis[0].data; 
        }
      }
    }
  }
  let orginal_data = JSON.parse(JSON.stringify(axis_data));
  let org_series_data = [];
  for (let m = 0; m < option.series.length; m++) {
    org_series_data[m] = JSON.parse(JSON.stringify(option.series[m].data));
  }
  let yuan_index = 0;
  for (let m = 0; m < sortValues.length; m++) {
    yuan_index = sortValues[m].myindex;
    axis_data[m] = orginal_data[yuan_index];
    //排序series
    for (let n = 0; n < option.series.length; n++) {
      option.series[n].data[m] = org_series_data[n][yuan_index];
    }
  }
  if (setting.mainaxis == 'xaxis') {
    if (option && option.xAxis && option.xAxis.length > 0) {
      for (let m = 0; m < option.xAxis.length; m++) {
        option.xAxis[m].data = axis_data;
      }//for m
    }
  } else if (setting.mainaxis == 'yaxis') {
    if (option && option.yAxis && option.yAxis.length > 0) {
      for (let m = 0; m < option.yAxis.length; m++) {
        option.yAxis[m].data = axis_data;
      }//for m
    }
  }
  org_series_data = null;
  orginal_data = null;
  return option;
}
//计算要排序的序列的占比
export function caclPerValues(option, allValues, seriesName) {
  let i = 0;
  let caclPerValues = [];
  let oneValue = 0;
  let data_type = '';
  if (option && option.series) {
    for (i = 0; i < option.series.length; i++) {
      if (option.series[i] && option.series[i].name == seriesName) {
        let m = 0;
        if (option.series[i] && option.series[i].data) {
          for (m = 0; m < option.series[i].data.length; m++) {
            data_type = Object.prototype.toString.call(option.series[i].data[m]);
            if (data_type == '[object Object]') {
              oneValue = option.series[i].data[m].value;  
            } else if (data_type == '[object Array]') {
              oneValue = option.series[i].data[m].value[1];
            } else {
              oneValue = option.series[i].data[m];
            }
            if (isNaN(oneValue * 1)) {
              oneValue = 0;
            } else {
              oneValue = oneValue * 1;
            }
            if (allValues && allValues[m] > 0) {
              caclPerValues[m] = { value: oneValue / allValues[m], myindex:m, orgValue: oneValue};
            } else {
              caclPerValues[m] = { value: 0, myindex:m, orgValue:0 };
            }
          }//for m
        }
        break;
      }
    }//for i
  }
  return caclPerValues;
}
//计算每个轴上不同系列的百分占比的总值
export function caclTotalValues(option) {
  let allvalue = [];
  let i = 0;
  let m = 0;
  let data_type = '';
  let oneValue = 0;
  if (option && option.series) {
    for (i = 0; i < option.series.length; i++) {
      if (option.series[i] && option.series[i].data) {
        for (m = 0; m < option.series[i].data.length; m++) {
          data_type = Object.prototype.toString.call(option.series[i].data[m]);
          if (data_type == '[object Object]') {
            oneValue = option.series[i].data[m].value;  
          } else if (data_type == '[object Array]') {
            oneValue = option.series[i].data[m].value[1];
          } else {
            oneValue = option.series[i].data[m];
          }
          if (isNaN(oneValue * 1)) {
            oneValue = 0;
          } else {
            oneValue = oneValue * 1;
          }
          if (allvalue[m] == undefined) {
            allvalue[m] = 0;
          }
          allvalue[m] = allvalue[m] + oneValue;
        }//for m
      }//for i
    }
  }
  return allvalue;
}
//处理图表的x轴或y轴的数据单位
export function modifyOptionAxisUnit(option) {
  //series中数据按照单位设置处理   配置了单位的轴，处理显示axisLabel:{format}
  let axisObjectType = '';
  let isNeedUnitChange = 0;
  //先检查Y轴
  if(option && option.yAxis) {
    axisObjectType = Object.prototype.toString.call(option.yAxis);
    if(axisObjectType == '[object Object]') {
      isNeedUnitChange = isNeedDowithAxis(option.yAxis);
      if(isNeedUnitChange == 1) {
        option = dowithAxisUnit(option,'yAxis',0,axisObjectType)
      }
    } else if(axisObjectType == '[object Array]') {
      for(let i = 0; i < option.yAxis.length; i++) {
        isNeedUnitChange = isNeedDowithAxis(option.yAxis[i]);
        if(isNeedUnitChange == 1) {
          option = dowithAxisUnit(option,'yAxis',i,axisObjectType)
        }
      }
    }
  }
  //再检查x轴
  if(option && option.xAxis) {
    axisObjectType = Object.prototype.toString.call(option.xAxis);
    if(axisObjectType == '[object Object]') {
      isNeedUnitChange = isNeedDowithAxis(option.xAxis);
      if(isNeedUnitChange == 1) {
        option = dowithAxisUnit(option,'xAxis',0,axisObjectType)
      }
    } else if(axisObjectType == '[object Array]') {
      for(let i = 0; i < option.xAxis.length; i++) {
        isNeedUnitChange = isNeedDowithAxis(option.xAxis[i]);
        if(isNeedUnitChange == 1) {
          option = dowithAxisUnit(option,'xAxis',i,axisObjectType);
        }
      }
    }
  }
  return option;
}
//处理需要 处理轴以及单位信息
function dowithAxisUnit(option,axisName,axisIndex,axisObjectType) {
  let i = 0;
  let unit='';
  let valuecnt = '-1';
  if(axisObjectType =='[object Object]') {
    if(option[axisName].axisLabel == undefined) {
      option[axisName].axisLabel = {};
    }
    option[axisName].axisLabel.formatter = '{value}'+option[axisName].axisLabel.unit;
    unit = option[axisName].axisLabel.unit;
    valuecnt = option[axisName].axisLabel.valuecnt;
    option[axisName].axisLabel.orgunit = unit;
    if (unit == '无' || unit == '') {
      delete option[axisName].axisLabel.formatter;
    }
  } else if(axisObjectType =='[object Array]') {
    if(option[axisName][axisIndex].axisLabel == undefined) {
      option[axisName][axisIndex].axisLabel = {};
    }
    option[axisName][axisIndex].axisLabel.formatter = '{value}'+option[axisName][axisIndex].axisLabel.unit;
    unit = option[axisName][axisIndex].axisLabel.unit;
    option[axisName][axisIndex].axisLabel.orgunit = unit;
    valuecnt = option[axisName][axisIndex].axisLabel.valuecnt;
    if (unit == '无' || unit == '') {
      delete option[axisName][axisIndex].axisLabel.formatter;
    }
  }
  if(valuecnt == undefined) {
    valuecnt = -1;
  }
  //处理series    数据格式有[1,3,54]  [{name:'dfdf',value:67}],[[12,34],[34,55]]  [{name:'df',value:[12,34]}]
  if(option.series) {
    let curAxisIndex = 0;
    let seriesObjectType = '';
    seriesObjectType = Object.prototype.toString.call(option.series);
    if(seriesObjectType == '[object Array]') {
      for(i = 0; i < option.series.length; i++) {
        curAxisIndex = 0;
        if(axisName=='xAxis') {
          if(option.series[i].xAxisIndex) {
            curAxisIndex = option.series[i].xAxisIndex;
          }
          if (curAxisIndex == axisIndex) {//需要处理
            if (option.series[i].orgdata == undefined) {
              option.series[i].orgdata = JSON.parse(JSON.stringify(option.series[i].data));
            }
            if (unit == '无' || unit == '') {
              option.series[i].data = JSON.parse(JSON.stringify(option.series[i].orgdata));
            } else {
              option.series[i].data = dowithSeriesByUnit(JSON.parse(JSON.stringify(option.series[i].orgdata)), axisName, unit, valuecnt,option.name);
            }
          }
        } else if(axisName=='yAxis') {
          if(option.series[i].yAxisIndex) {
            curAxisIndex = option.series[i].yAxisIndex;
          }
          if (curAxisIndex == axisIndex) {//需要处理
            if (option.series[i].orgdata == undefined) {
              option.series[i].orgdata = JSON.parse(JSON.stringify(option.series[i].data));
            }
            if (unit == '无' || unit == '') {
              option.series[i].data = JSON.parse(JSON.stringify(option.series[i].orgdata));
            } else {
              option.series[i].data = dowithSeriesByUnit(JSON.parse(JSON.stringify(option.series[i].orgdata)), axisName, unit, valuecnt,option.name);
            }
          }
        }
      }//for i
    } else if(seriesObjectType == '[object Object]') {
      curAxisIndex = 0;
      if(axisName=='xAxis') {
        if(option.series.xAxisIndex) {
          curAxisIndex = option.series.xAxisIndex;
        }
        if (curAxisIndex == axisIndex) {//需要处理
          if (option.series.orgdata == undefined) {
            option.series.orgdata = JSON.parse(JSON.stringify(option.series.data));
          }
          if (unit == '无' || unit == '') {
            option.series.data = JSON.parse(JSON.stringify(option.series.orgdata));
          } else {
            option.series.data = dowithSeriesByUnit(JSON.parse(JSON.stringify(option.series.orgdata)), axisName, unit, valuecnt,option.name);
          }
        }
      } else if(axisName=='yAxis') {
        if(option.series.yAxisIndex) {
          curAxisIndex = option.series.yAxisIndex;
        }
        if (curAxisIndex == axisIndex) {//需要处理
          if (option.series.orgdata == undefined) {
            option.series.orgdata = JSON.parse(JSON.stringify(option.series.data));
          }
          if (unit == '无' || unit == '') {
            option.series.data = JSON.parse(JSON.stringify(option.series.orgdata));
          } else {
            option.series.data = dowithSeriesByUnit(JSON.parse(JSON.stringify(option.series.orgdata)), axisName, unit, valuecnt,option.name);
          }
        }
      }
    }
  }

  return option;
}
//处理series中的数据  根据轴设置的单位   数据格式有[1,3,54]  [{name:'dfdf',value:67}],[[12,34],[34,55]]  [{name:'df',value:[12,34]}]
function dowithSeriesByUnit(data,axisName,unit,valuecnt,chartname) {
  if(data) {
    let curdataType = '';
    let orgValue = '';
    for(let i = 0; i < data.length ; i++) {
      curdataType = Object.prototype.toString.call(data[i]);
      if(curdataType == '[object Object]') {
        let typeTmp  = Object.prototype.toString.call(data[i].value);
        if(typeTmp == '[object String]' || typeTmp == '[object Number]') {
          data[i].value = dowithValueByUnit(data[i].value,unit,valuecnt);
        }else if(typeTmp == '[object Array]') {
          if(data[i].value.length >= 2) {
            if(axisName == 'xAxis') {
              data[i].value[0] = dowithValueByUnit(data[i].value[0],unit,valuecnt);
            } else if(axisName == 'yAxis') {
              data[i].value[1] = dowithValueByUnit(data[i].value[1], unit, valuecnt);
              if (chartname == '瀑布图') {
                data[i].value[0] = dowithValueByUnit(data[i].value[0], unit, valuecnt);
              }
            }
          }
        } else if(typeTmp == undefined) {//不处理
        }
        
      } else if(curdataType == '[object Array]') {
        if(data[i].length >= 2) {
          if(axisName == 'xAxis') {
            data[i][0] = dowithValueByUnit(data[i][0],unit,valuecnt);
          } else if(axisName == 'yAxis') {
            data[i][1] = dowithValueByUnit(data[i][1], unit, valuecnt);
            if (chartname == '瀑布图') {
              data[i][1] = dowithValueByUnit(data[i][0], unit, valuecnt);
            }
          }
        }
      } else if(curdataType == undefined) {//不处理了
      } else if(curdataType == '[object Number]' || curdataType == '[object String]') {
        data[i] = dowithValueByUnit(data[i],unit,valuecnt);
      }
    }//for i
  }
  return data;
}
///根据单位和保留位数对数值进行处理
function dowithValueByUnit(value,unit,valuecnt) {
  if(isNaN(value*1)) {
    //不处理
  } else {
    if(unit == '千') {
      value = value*1/1000;
    } else if(unit == '万') {
      value = value*1/10000;
    } else if(unit == '十万') {
      value = value*1/100000;
    } else if(unit == '百万') {
      value = value*1/1000000;
    } else if(unit == '千万') {
      value = value*1/10000000;
    } else if(unit == '亿') {
      value = value*1/100000000;
    } else if(unit == '十亿') {
      value = value*1/1000000000;
    } else if(unit == '百亿') {
      value = value*1/10000000000;
    } else if(unit == '千亿') {
      value = value*1/100000000000;
    }
  }
  if(isNaN(value*1)) {

  }
  else if(valuecnt*1 >= 0) {
    value = value.toFixed(valuecnt*1);
  }
  return value;
}
//检查轴是否需要处理单位设置
function isNeedDowithAxis(axisObject) {//axisLabel
  let isNeedUnitChange = 0;
  if(axisObject) {
    if(axisObject.type == undefined || axisObject.type == 'value') {
      if(axisObject.axisLabel && axisObject.axisLabel.unit != undefined && axisObject.axisLabel.unit !='无' && axisObject.axisLabel.unit !='') {
        //if(axisObject.axisLabel && axisObject.axisLabel.formatter) {
         // if(axisObject.axisLabel.formatter == '{value}'+axisObject.axisLabel.unit) {//已经处理过了
         //   isNeedUnitChange = 0;
         // } else {
        //    isNeedUnitChange = 1;
         // }
       // } else {
          isNeedUnitChange = 1;
        //}
        if (isNeedUnitChange == 0) {//只改变小数点
          if (axisObject.axisLabel) {
            if (axisObject.axisLabel.orgunit != axisObject.axisLabel.unit) {
              isNeedUnitChange = 1;
            }
          }
        }
      }
      //从有到无的地方
      if (isNeedUnitChange == 0) {
        if (axisObject.axisLabel && axisObject.axisLabel.unit == '无') {
          if (axisObject.axisLabel.formatter == '{value}' + axisObject.axisLabel.orgunit) {
            isNeedUnitChange = 1;
          }
        }
      }
    }
  }
  return isNeedUnitChange;
}
///对于图例特别多的 提示框自动处理
export function setTooltipStyle(option) {
  //12->24->32
  if (option) {
    let bset = false;
    if (option.tooltip && (option.tooltip.show == true || option.tooltip.show == undefined) && option.tooltip.trigger=='axis') {
      bset = true;
    }
    if (bset == true) {
      let tooltipcnt = 0;
      if (option.tooltipcnt) {
        tooltipcnt = option.tooltipcnt;//兼容原来的
      } else if (option.HLtooltip && option.HLtooltip.tooltipcnt) {//HLtooltip
        tooltipcnt = option.HLtooltip.tooltipcnt;
       }  else {//计算tooltipcnt
        let seriescnt = 1;
        if (option.series) {
          if (Object.prototype.toString.call(option.series) == '[object Array]') {
            seriescnt = option.series.length;
          } else {
            seriescnt = 1;
          }
        }
        //tooltipcnt = seriescnt;
        if (seriescnt * 1 < 10) {
          tooltipcnt = 1;
        } else if (seriescnt * 1 >= 10 && seriescnt * 1 < 17) {
          tooltipcnt = 2;
        } else if (seriescnt * 1 >= 17 && seriescnt * 1 < 25) {
          tooltipcnt = 3;
        } else if (seriescnt * 1 >= 25 && seriescnt * 1 < 33) {
          tooltipcnt = 4;
        } else if (seriescnt * 1 >= 33 && seriescnt * 1 < 41){
          tooltipcnt = 5;
        } else if (seriescnt * 1 >= 41 && seriescnt * 1 < 49){
          tooltipcnt = 6;
        } else if (seriescnt * 1 >= 49 && seriescnt * 1 < 57){
          tooltipcnt = 7;
        } else if (seriescnt * 1 >= 57){
          tooltipcnt = 8;
        }
      }
      let func1 = "function formatter(params) { var p_type = Object.prototype.toString.call(params); let tooltipcnt = option.tooltipcnt; if (p_type == '[object Object]') { let dataIndex = params.dataIndex; let name = params.name; if (tooltipcnt) { var html = '<div style=\\\"display:block;text-align:left;\\\">' + name + '</div>'; var one = ''; if (option && option.series) { for (var i = 0; i < option.series.length; i++) { var s_name = option.series[i].name; var value = option.series[i].data[dataIndex]; var qu = (i + 1) % (tooltipcnt * 1); if (qu > 0) { if (one == '') one = s_name + ':' + value; else one = one + ';&nbsp;&nbsp;&nbsp;&nbsp;' + s_name + ':&nbsp;&nbsp;' + value; } else { one = '<p style=\\\";text-align:left;\\\">' + one + ';&nbsp;&nbsp;&nbsp;&nbsp;' + s_name + ':&nbsp;&nbsp;' + value + '</p>'; html = html + one; one = ''; } } if (one != '') html = html + '<p style=\";text-align:left;\">' + one + '</p>'; return html; } } else return name + '<br>' + params.seriesName + ':' + params.value; } else if (p_type == '[object Array]') { if (tooltipcnt == 0 || tooltipcnt == undefined) { tooltipcnt = 1; } if (tooltipcnt) { let tooltipcnt = option.tooltipcnt; let name = ''; let one = ''; if (params && params[0] && params[0].name) name = params[0].name; var html = '<div style=\"display:block;;text-align:left;\">' + name + '</div>'; for (var i = 0; i < params.length; i++) { let dataIndex = params[i].dataIndex; let seriesName = params[i].seriesName; let value = params[i].value; let color = params[i].color; var qu = (i + 1) % (tooltipcnt * 1); if (qu > 0) { if (one == '') { one = '<span style=\"display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + color + ';\"></span>' + seriesName + ':' + value; } else one = one + '\t&nbsp;&nbsp;<span style=\"display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + color + ';\"></span>' + seriesName + ':&nbsp;&nbsp;' + value; } else { one = '<p style=\";text-align:left;\">' + one + '\t&nbsp;&nbsp;<span style=\"display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + color + ';\"></span>' + seriesName + ':&nbsp;&nbsp;' + value + '</p>';html = html + one;one = '';}}if (one != '') {html = html + '<p style=\";text-align:left;\">' + one + '</p>';}return html;}}}";
      if (tooltipcnt > 1) {
        option.tooltipcnt = tooltipcnt;
        option.tooltip.formatter = eval('(' + func1 + ')');
      }
    }
    //tooltip.formatter   option.tooltip.formatter = eval('(' + this.func1 + ')');
  }
  return option;
}


